import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  Switch,
  Table,
  Typography,
  TableBody,
  TableRow,
  TableContainer,
} from '@mui/material';
import { debounce } from 'lodash';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Unstable_Grid2';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import api from '../../../services/api';

const StatusManagementItem = ({
  checkedFields,
  schema,
  names,
  onCheck,
}: {
  checkedFields: any;
  schema: any;
  onCheck: (value: boolean) => void;
  names: any;
}) => {
  const [rows, setRows] = useState(checkedFields);
  const [loading, setLoading] = useState(false);
  const [addNewEntity, setAddNewEntity] = React.useState(false);
  const [openedSlidingPane, setOpenedSlidingPane] = useState(undefined);
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(undefined);

  const fetchStatuses = useCallback(() => {
    setLoading(true);

    const searchParams = new URLSearchParams({});

    schema.client.readAll(1, searchParams).then((result: any) => {
      setRows(result?.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {}, []);

  const handleDeleteClick = (row: any) => {
    setOpenConfirmDialog(row);
  };

  const handleEditClick = (row: any) => {
    setOpenedSlidingPane(row);
  };

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);

  function handleDebouncedOnChange(
    schema: any,
    column: string,
    checked: boolean
  ) {
    api.patch(`/check-required-fields`, {
      column: column,
      table: schema?.table,
      checked: checked,
    });
  }
  return (
    <>
      <Grid sm={12} md={6} lg={3}>
        <Box>
          <Card variant="outlined">
            <CardContent>
              <Typography variant={'h6'} color="#666" gutterBottom>
                {schema?.name}
              </Typography>
              <TableContainer>
                <Table
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '5px',
                    },
                    opacity: loading ? 0.5 : 1,
                    pointerEvents: loading ? 'none' : 'all',
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="right">Required</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      maxHeight: '300px',
                    }}
                  >
                    <>
                      {schema.columns.map((row: any, index: any) => {
                        return (
                          <TableRow key={index}>
                            <TableCell align="left">
                              {names?.[schema?.table]?.[row?.name] ?? ''}
                            </TableCell>
                            <TableCell align="right">
                              <Switch
                                defaultChecked={checkedFields[`${row?.name}`]}
                                onChange={(event, checked) => {
                                  debouncedOnChange(schema, row?.name, checked);
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Box>
      </Grid>
    </>
  );
};
export default StatusManagementItem;
